import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'timespointmodal' */ './TimesPointModal'),
  loading: () => null,
  // timeout: 50000,
});

class WithTimesPointModal extends React.Component {
  constructor() {
    super();
    this.state = {
      isClientSide: false,
    };
    this.LoadableComponent = null;
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    if (
      window.TimesGDPR &&
      window.TimesGDPR.common.consentModule.gdprCallback
    ) {
      window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
        if (!dataObj.isEUuser) {
          this.setState({ isClientSide: true });
        }
      });
    }
  }
  render() {
    if (!this.state.isClientSide) {
      return null;
    }

    return <LoadableComponent {...this.props} />;
  }
}

export default WithTimesPointModal;
